import { Injectable } from '@angular/core'; 
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { share } from 'rxjs/operators';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';
import { Filter } from '../models/filter';
import { ParameterConst } from '../util/constant';
import { Md5 } from 'ts-md5';
import { Tematica } from '../models/tematica';

@Injectable({
  providedIn: 'root'
})
export class TematicaService { 
  
  private url_get_tematica = environment.apiEndpoint + "api/obtenerTematica.php";
  private url_update_tematica = environment.apiEndpoint + "api/editarTematica.php";

  constructor(private _http:HttpClient){}
  
  obtenerTematica(sqTematica : string): Observable<any>{

    const formData = new FormData();
    formData.append("sqTematica", sqTematica);

    return this._http.post(this.url_get_tematica,formData).pipe(share());

  }
 


  actualizarTematica(tematica: Tematica): Observable<any>{

    const formData = new FormData();
    formData.append("sumilla", tematica.sumilla);
    formData.append("sqTematica", tematica.sqTematica);

    if(tematica.imgFile){
      formData.append("imgFile", tematica.imgFile);  
    }
  
    var sessionStr = JSON.parse(localStorage.getItem(ParameterConst.USER_LOGIN));
    formData.append("usuariocre", sessionStr['squsuario']);

    return this._http.post(this.url_update_tematica,formData).pipe(share());
   
  }

 
  

}
 
